import { Component, HostBinding } from '@angular/core';
import { CampaignField } from '@fmnts/api/next';
import { AbstractDeclarativeInputFieldComponent } from '@fmnts/declarative-forms';
import { faSquare, faSquareCheck } from '@fortawesome/pro-regular-svg-icons';
import { SharedDeclarativeCampaignFormsModule } from '../../shared-declarative-next-forms.module';

type FieldValue = boolean;

/**
 * Component that displays a single checkbox
 */
@Component({
  selector: 'next-checkbox-field',
  templateUrl: './checkbox-field.component.html',
  standalone: true,
  imports: [SharedDeclarativeCampaignFormsModule],
})
export class CheckboxFieldComponent extends AbstractDeclarativeInputFieldComponent<
  CampaignField,
  FieldValue
> {
  @HostBinding('class') componentClass = 'form-field form-field__checkbox';

  /** Icon to use, if state is checked */
  public readonly iconChecked = faSquareCheck;
  /** Icon to use, if state is unchecked */
  public readonly iconUnchecked = faSquare;

  get value() {
    return this._value;
  }
  set value(value) {
    this._value = value;
    this._onChange(value);
    this._onTouched();
  }
  private _value = false;

  writeValue(value) {
    this._value = value;
  }

  public toggleChecked() {
    this.value = !this.value;
  }

  public isChecked() {
    return this.value === true;
  }
}
